import { Post, Get, Put } from "@/utils";
import { ApiPath } from "@/enums";

export default {
  namespaced: true,
  state: {
    current_user: null,
    zipCodes: []
  },
  mutations: {
    SET_USER(state, payload) {
      state.current_user = payload;
    },
    SET_ZIPCODES(state, payload) {
      state.zipCodes = payload;
    }
  },
  actions: {
    // register({}, registration) {
    //   return axios
    //     .post(
    //       `${process.env.VUE_APP_API_BASE_URI}jobseeker/register`,
    //       registration
    //     )
    //     .then(() => {
    //       //commit('SET_REGISTRATION', registration);
    //       //return registration;
    //     })
    //     .catch((res) => {
    //       const errors = res.response.data;
    //       throw errors;
    //     });
    // },
    // sendRegEmail({}, registration) {
    //   return axios
    //     .post(
    //       `${process.env.VUE_APP_API_BASE_URI}jobseeker/sendEmail`,
    //       registration
    //     )
    //     .then(() => {
    //       //commit('SET_REGISTRATION', registration);
    //       //return registration;
    //     })
    //     .catch((res) => {
    //       const errors = res.response.data;
    //       throw errors;
    //     });
    // },

    // TODO: to be replaced with userAuthentication.methods.userLoggedIn() in view layer
    // isLogged() {
    //   return axios.get(`${process.env.VUE_APP_API_BASE_URI}identity/Login`);
    // },
    // getsurvey() {
    //   return axios.get(
    //     `${process.env.VUE_APP_API_BASE_URI}employee/getsurveyquestions`
    //   );
    // },
    // getsurveycaptured() {
    //   return axios.get(
    //     `${process.env.VUE_APP_API_BASE_URI}employee/getsurveycaptured`
    //   );
    // },
    // capturedsurvey({ }, survey) {
    //   return axios
    //     .post(`${process.env.VUE_APP_API_BASE_URI}employee/savesurvey`, survey)
    //     .then((res) => {
    //       return res.data;
    //     });
    // },
    async acceptInvite({}, body) {
      const { data: invitation } = await Post(
        `${ApiPath.JobSeeker}/acceptinvite`,
        body
      );
      return invitation;
    },
    async cancelJobMatch({}, talentPoolId) {
      const { data: invitation } = await Post(
        `${ApiPath.JobSeeker}/declineinvite`,
        talentPoolId
      );
      return invitation;
    },

    async searchjob(
      {},
      {
        userId,
        weighting,
        distance,
        certificate,
        pageCount,
        keyword,
        searchtype
      }
    ) {
      const { data: jobs } = await Get(
        `${ApiPath.JobSeekerSurvey}/searchjob?userId=${userId}&weighting=${weighting}&distance=${distance}&certificate=${certificate}&pageCount=${pageCount}&keyword=${keyword}&searchtype=${searchtype}`
      );
      return jobs;
    },

    //TODO: Missing Endpoint
    async getRoleMatches(
      { commit },
      {
        jobseekerUserId,
        weighting,
        distance,
        certificate,
        pageCount,
        percentage
      }
    ) {
      const { data: roleMatches } = await Get(
        `${ApiPath.RoleMatching}/getvacantroles?jobseekerUserId=${jobseekerUserId}&weighting=${weighting}&distance=${distance}&certificate=${certificate}&pageCount=${pageCount}&percentage=${percentage}`
      );
      commit("SET_SGA", roleMatches);
      return roleMatches;
    },
    async applyForRole({}, body) {
      const { data: roleApplication } = await Post(
        `${ApiPath.JobSeeker}/applyforrole`,
        body
      );
      return roleApplication;
    },
    async getAppliedForRoles({}) {
      const { data: roleApplication } = await Get(
        `${ApiPath.JobSeeker}/getappliedforroles`
      );
      return roleApplication;
    },
    // async getAppliedForRoles({ }, talentPoolId) {
    //   const { data: roleApplication } = await Get(
    //     `${ApiPath.JobSeeker}/acceptjoboffer`,
    //     talentPoolId
    //   );
    //   return roleApplication;
    // },
    async getMyApplications({}) {
      const { data: roleApplication } = await Get(
        `${ApiPath.JobSeeker}/getmyapplications`
      );
      return roleApplication;
    },
    // async getMyApplications({ }) {
    //   const { data: myApplications } = await Get(
    //     `${ApiPath.JobSeeker}/getagencyconnectionrequest`,
    //   );
    //   return myApplications;
    // },
    async updatecaseworkersearchstatus({}, caseworkersearchstatus) {
      const { data: myCaseWorkerSearachStatus } = await Put(
        `${ApiPath.JobSeeker}/updatecaseworkersearchstatus?status=${caseworkersearchstatus}`
      );
      return myCaseWorkerSearachStatus;
    },
    async getcaseworkersearchstatus({}) {
      const { data: myCaseWorkerSearachStatus } = await Get(
        `${ApiPath.JobSeeker}/getcaseworkersearchstatus`
      );
      return myCaseWorkerSearachStatus;
    },
    async getagencies({}, radius) {
      const { data: agencies } = await Get(
        `${ApiPath.JobSeeker}/getagencies?radius=${radius}`
      );
      return agencies;
    },
    async sendConnection({}, body) {
      const { data: myConnection } = await Post(
        `${ApiPath.JobSeeker}/sendconnection`,
        body
      );
      return myConnection;
    },
    async getagencyconnectionrequests({}) {
      const { data: myConnectionRequests } = await Get(
        `${ApiPath.JobSeeker}/getagencyconnectionrequest`
      );
      return myConnectionRequests;
    },
    async acceptagencyconnectionrequest({}, body) {
      const { data: connectionRequests } = await Post(
        `${ApiPath.JobSeeker}/acceptagencyconnectionrequest`,
        body
      );
      return connectionRequests;
    },
    async declineagencyconnectionrequest({}, requestId) {
      const { data: connectionRequests } = await Post(
        `${ApiPath.JobSeeker}/declineagencyconnectionrequest?requestId=${requestId}`
      );
      return connectionRequests;
    },
    async removeCareerCenterConnectionrequest({}, { inviteId, reason, details}) {
      let declineagencyconnectionrequestUrl =  `${ApiPath.JobSeeker}/declineagencyconnectionrequest?requestId=${inviteId}&reason=${reason}`
      if (details !== null && details !== undefined) declineagencyconnectionrequestUrl = declineagencyconnectionrequestUrl + `&reasonDetails=${details}`;

      const { data: connectionRequests } = await Post(declineagencyconnectionrequestUrl);
      return connectionRequests;
    },
    async undodeclinedagencyconnectionrequest({}, requestId) {
      const { data: connectionRequests } = await Put(
        `${ApiPath.JobSeeker}/undodeclinedagencyconnectionrequest?requestId=${requestId}`
      );
      return connectionRequests;
    },
    async getmysentagencyconnectionrequests({}) {
      const { data: mySentConnectionRequests } = await Get(
        `${ApiPath.JobSeeker}/getmysentagencyconnectionrequests`
      );
      return mySentConnectionRequests;
    },
    async deletemysentagencyconnectionrequests({}, requestId) {
      const { data: mySentConnectionRequests } = await Get(
        `${ApiPath.JobSeeker}/deletemysentagencyconnectionrequests?requestId=${requestId}`
      );
      return mySentConnectionRequests;
    },
    async getconnnectedcaseworkers({}) {
      const { data: connectedCaseWorker } = await Get(
        `${ApiPath.JobSeeker}/getconnnectedcaseworkers`
      );
      return connectedCaseWorker;
    },
    async deletemycaseworkerassigned({}, referenceId) {
      const { data: caseworkerAssigned } = await Get(
        `${ApiPath.JobSeeker}/deletemycaseworkerassigned?referenceId=${referenceId}`
      );
      return caseworkerAssigned;
    },
    async getRequestBoard({}, status) {
      const { data: requestBoard } = await Get(
        `${ApiPath.JobSeeker}/requestboard?status=${status}`
      );
      return requestBoard;
    },

    async getRoleInfo({}, employeeId) {
      const { data: roleInfo } = await Get(
        `${ApiPath.OrganisationVacantSurvey}/getorganisationvacantsga?employeeId=${employeeId}`
      );
      return roleInfo;
    },

    async createJobseekerReassignRequest({}, request) {
      const { data: reminder } = await Post(
        `${ApiPath.JobSeeker}/createjobseekerreassignrequest`,
        request
      );
      return reminder;
    },

    async sendReminderReassignRequest({}, request) {
      const { data: reminder } = await Post(
        `${ApiPath.JobSeeker}/sendremindertocaseworkerreassign`,
        request
      );
      return reminder;
    },

    async sendReminderToAgencyConnection({}, inviteId) {
      const { data: reminder } = await Post(
        `${ApiPath.JobSeeker}/sendremindertoagencyconnection?inviteId=${inviteId}`
      );
      return reminder;
    },

    checkEducationDetails() {
      const userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}common/checkeducationdetails?userid=${userid}&usertype=JOBSEEKER`
        )
        .then(res => {
          return res;
        })
        .catch(res => {
          const errors = res.response;
          throw errors;
        });
    },
    async acceptJobOffer({}, talentPoolId) {
      const { data: roleInfo } = await Post(
        `${ApiPath.JobSeeker}/acceptjoboffer?talentPoolId=${talentPoolId}`
      );
      return roleInfo;
    },
    async cancelJobMatch({}, talentPoolId) {
      const { data: roleInfo } = await Post(
        `${ApiPath.JobSeeker}/declineinvite?talentPoolId=${talentPoolId}`
      );
      return roleInfo;
    },

    async createjobseekerremotecheckin({}, request)
    {
      const { data: checkinInfo } = await Post(
        `${ApiPath.JobSeeker}/createjobseekerremotecheckin`,
        request
      );
      return checkinInfo;
    },

    async getRegistrationAnswerByJobSeekerId({}, jobSeekerId) {
      const { data: registrationAnswers } = await Get(
        `${ApiPath.JobSeeker}/getregistrationanswerbyjobseekerid/${jobSeekerId}`
      );
      return registrationAnswers;
    },
    async addRegistrationAnswer({}, request) {
      const { data: reminder } = await Post(
        `${ApiPath.JobSeeker}/addregistrationanswer`,
        request
      );
      return reminder;
    },
    async updateRegistrationAnswer({}, request) {
      const { data: reminder } = await Put(
        `${ApiPath.JobSeeker}/updateregistrationanswer`,
        request
      );
      return reminder;
    },
  }
};
